import React from "react";
import { Container, Grid } from "@material-ui/core";
import CardPayments from "./CardPayments";
import NewPayment from "./NewPayment";
import { useRole } from "../../hooks/useRole";

export default function Payments() {
  const { isAdmin } = useRole();
  return (
    <Container maxWidth="lg">
      <Grid container spacing={1}>
        <Grid item sm={isAdmin ? 6 : 12} xs={12}>
          <CardPayments />
        </Grid>
        {isAdmin && (
          <Grid item sm={6} xs={12}>
            <NewPayment />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
